import useHidesCustomerPriorities from 'hooks/use-hides-customer-priorities';
import CustomerPreferencesQuestionsSection from './customer-preferences-questions-section';
import CustomerPrioritiesSection from './customer-priorities-section';

// The side panel's content. The priorities sliders score the ductless
// gallery only; on the compatibility (ducted) and PTAC pathways the Choose
// Systems grid is ordered without them, so the sliders stay out and the
// panel holds the preference questionnaire alone.
export default function CustomerPreferencesSection() {
  const hidesCustomerPriorities = useHidesCustomerPriorities();

  return (
    <div className='flex flex-col gap-4'>
      {!hidesCustomerPriorities && <CustomerPrioritiesSection />}
      <CustomerPreferencesQuestionsSection />
    </div>
  );
}
